/* eslint-disable max-len */

export default {
  lang: 'French',
  homeScreen: {
    title: 'Les îles des Bahamas',
    subTitle: 'Fly Away',
    stayConnected: 'Restez en contact',
    comingSoon: 'Prochainement',
    messages: 'Messages',
  },
  notification: {
    newAndNow: 'Nouveau & Maintenant!',
    alert: 'Alerte',
    contest: 'Concours',
    message: 'Contenu',
    events: 'Événement',
    news: 'Actualités',
    welcome: 'Bienvenue',
  },
  directory: {
    view: 'Voir maintenant >',
    reset: 'Réinitialiser les filtres >',
    results: 'Nombre de résultats',
    acco: "Filtrer par type d'hébergement",
    price: 'Filtrer par prix',
    island: 'Filtrer par île',
    additional: 'Filtres supplémentaires :',
    accessibleproperty: 'Propriété accessible',
    beachfront: 'Front de mer',
    casino: 'Casino',
    divecenter: 'Centre de plongée',
    fishinglodge: 'Fishing Lodge',
    golf: 'Golf',
    marina: 'Marina',
    selfcatering: 'Self-Catering',
    waterfront: 'Front de mer',
    noResults:
      'Aucun résultat trouvé. veuillez essayer avec une autre recherche.',
    search: 'Rechercher une annonce...',
    back: 'retour',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Voyons si nous pouvons trouver un profil existant pour vous dans notre système.',
      homeTitleSub:
        "Saisissez l'adresse électronique que vous utilisez habituellement pour vous connecter aux programmes de formation.",
      noAccount:
        "Aucun compte n'a été trouvé ({email}), veuillez essayer avec un autre email ou créer un compte maintenant.",
      continueButton: 'Continuer',
      success:
        "La mise à jour de votre compte a été effectuée avec succès ! Vous serez bientôt redirigé vers la page d'accueil.",
      successNewAccount:
        'Pour compléter votre inscription, vous recevrez un courriel de confirmation pour vérifier votre compte.',
      loginButton: 'Connexion',
      matchFound:
        'Nous avons trouvé une correspondance, veuillez saisir votre mot de passe pour continuer.',
      magicLink:
        "Connectez-vous à l'aide d'un lien figurant dans votre courrier électronique :",
      magicLinkButton: 'Demande de lien magique',
      magicLinkTitle:
        'Un lien direct vous est envoyé par e-mail pour vous permettre de vous inscrire instantanément.',
      otherEmailButton: 'Soumettre',
      title:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      titleIndustry:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      register: 'Créer un compte',
      agent: 'Conseiller en voyages',
      visitor: "Visiteur de l'industrie",
      step1: "Étape 1 : Type d'utilisateur",
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      marketingOptIn:
        "Êtes-vous sûr de ne pas vouloir rester en contact avec l'équipe commerciale de ce programme ?",
      optIn: 'Oui, je suis intéressé',
      optOut: 'Pas intéressé',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      privacyHead: 'LES PRÉFÉRENCES EN MATIÈRE DE COMMUNICATION',
      privacySub:
        "Cochez les cases ci-dessous pour vous assurer de recevoir les communications importantes de l'équipe commerciale du fournisseur (mises à jour et annonces de produits, récompenses, incitations, FAM, etc.) et les initiatives de TravPRO Mobile en matière de réseautage et d'aide à la vente pour les professionnels du voyage.",
      privacy:
        "Nous protégeons votre vie privée et ne vendons pas, n'utilisons pas à mauvais escient et ne trahissons pas votre confiance.",
      store:
        "Téléchargez facilement ce programme dans votre magasin d'applications :",
      powered: 'ALIMENTÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous vous avons envoyé par e-mail le lien de réinitialisation de votre mot de passe ! Vous serez redirigé vers la page de connexion dans 10 secondes.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
        magicLinkMessage:
          'Veuillez patienter, nous sommes en train de vous inscrire.',
        magicLinkError:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkError1:
          "Nous n'avons pas trouvé de jeton valide, veuillez vous connecter ou demander un nouveau lien magique. Si le problème persiste, veuillez nous contacter à l'adresse suivante : info@travpromobile.com.",
        magicLinkError2:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkSuccess:
          "Consultez votre courrier électronique à l'adresse {email}. Il contient un lien magique qui vous permettra de vous connecter.",
        magicLinkErrorWait:
          'Veuillez attendre 5 minutes entre les demandes de liens magiques.',
        emailNotFoundError:
          "L'adresse électronique que vous avez saisie ne figure pas dans nos dossiers. Veuillez vérifier les fautes d'orthographe ou créer un compte.",
      },
      errors: {
        zipCodeNotFound: 'Code postal non trouvé, réessayez',
        zipCodeOnlyNumbers: 'ZipCode ne peut contenir que des chiffres',
        password: 'Veuillez saisir un mot de passe',
        passwordNotMatching: 'Les mots de passe saisis ne correspondent pas',
        passwordTooShort:
          'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          "Cette adresse électronique existe déjà ou n'est pas valide. Veuillez essayer avec une autre adresse électronique ou vous connecter à votre compte.",
        fillInAllFields: 'Veuillez remplir tous les champs obligatoires',
        fillInEmail: 'Veuillez indiquer votre adresse électronique.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
      },
      fields: {
        forgotSubCopy:
          'Vous avez oublié votre mot de passe et souhaitez le modifier ? ',
        forgotSubCopy2:
          'Vous voulez éviter le mot de passe ? Nous vous enverrons un e-mail contenant un lien magique qui vous permettra de vous connecter automatiquement au programme.',
        city: 'Ville',
        companyName: "Nom de l'entreprise",
        role: 'Votre rôle',
        description:
          "Laquelle décrit le mieux l'activité de votre entreprise ?",
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisissez un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: "Nom de l'agence",
        title: 'Votre rôle (Sélectionnez un rôle)',
        company: "Nom de l'entreprise",
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate:
          'Quel est le groupe auquel vous êtes PRINCIPALEMENT affilié ?',
        hostAgency: "Votre agence d'accueil ?",
        executive: 'Cadre',
        management: 'Gestion',
        marketing: 'Marketing',
        sales: 'Vente',
        coordinator: 'Coordinateur',
        opt: "Restez en contact avec l'équipe commerciale de ce programme et recevez des mises à jou",
        optMarketing:
          'Restez en contact avec TravPRO en ce qui concerne les programmes et événements similaires.',
        retail: "Façade d'un magasin de détail",
        home: 'Agent à domicile',
        independent: 'Entrepreneur indépendant',
        host: "Agence d'accueil",
        call: "Centre d'appel ou agence en ligne",
        other: 'Autres',
        describes:
          "Qu'est-ce qui décrit le mieux votre activité et celle de votre agence ?",
      },
    },
    title:
      'Formation pour les spécialistes du tourisme et programme d’aide à la vente',
    forgot: 'Réinitialiser le mot de passe',
    forgotCopylong:
      'Vous avez oublié votre mot de passe ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
    forgotHeader:
      "Veuillez fournir l'adresse e-mail que vous avez utilisée lors de votre inscription à votre compte Bahamas Specialist. Nous vous enverrons un e-mail qui vous permettra de réinitialiser votre mot de passe",
    welcome: {
      headerTop: 'Bienvenue dans',
      headerBottom: 'le programme dédié aux spécialistes des Bahamas',
    },
    sellingPoints: {
      0: 'Formation multimédia sur plusieurs appareils',
      1: 'Attestation de formation',
      2: 'Présentations commerciales prêtes à l’emploi',
      3: 'Supports de vente à fort impact',
      4: 'Nos conseils et promotions',
      5: 'Répertoire de produits en temps réel',
      6: 'Actualités et mises à jour',
      7: 'Veuillez saisir votre adresse électronique et votre mot de passe pour confirmer que vous êtes un·e spécialiste du tourisme.',
    },
    emailPrompt:
      'En poursuivant, vous acceptez notre politique de confidentialité ainsi que nos conditions générales',
    tAndC: {
      agree: "En continuant, vous êtes d'accord avec notre ",
      privacyPolicy: 'politique de confidentialité',
      and: ' et ',
      termsConditions: "'termes et conditions",
    },
    fields: {
      forgot: 'Réinitialiser le mot de passe',
      forgotCopylong:
        'Vous avez oublié votre mot de passe ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
      agency: 'Agence',
      email: 'E-mail',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom',
      agencyName: 'Nom de l’agence',
      stateProvince: 'Région / Pays',
      required: 'Obligatoire',
      invalidEmail: 'L’adresse électronique n’est pas valide',
      opt: 'Recevez nos alertes ! Oui, je souhaite recevoir des informations sur les Bahamas afin de connaître les actualités, les événements, les incitations, les voyages de familiarisation et bien plus encore !',
    },
    noAgent: {
      noAgentButton: 'Je ne suis pas un conseiller',
      title: 'Merci pour l’intérêt que vous portez aux Bahamas.',
      messageWeb:
        'Le contenu de ce site est réservé aux spécialistes du tourisme. \n Pour en savoir plus sur les Bahamas, veuillez consulter :',
      messageMobile:
        'Une partie du contenu disponible sur cette application est réservée aux spécialistes du tourisme, mais n’hésitez pas à découvrir ses avantages en appuyant sur « Continuer ».',
      continue: 'Continuer',
      visitWebsite: 'Consulter le site internet',
    },
    newUser: 'Nouvelle utilisatrice ou nouvel utilisateur',
    register: 'S’enregistrer',
    registered: 'Cette adresse électronique est déjà enregistrée',
  },
  welcomeScreen: {
    title:
      'Bienvenue sur Sales Companion,\nl’application des spécialistes des Bahamas',
    helloUser: 'Bonjour {{name}}',
    hello: 'Bonjour,',
    fromAgency: 'de l’agence {{agency}}',
    notUser: 'Vous n’êtes pas {{name}} ?',
    introOnline:
      'Formez-vous immédiatement en ligne ou téléchargez le contenu pour y accéder hors ligne.',
    introOffline:
      'Vous avez déjà téléchargé la dernière version. Commencez à vous former ou à vendre à n’importe quel moment, depuis n’importe où !',
    startTraining: 'Commencer la formation',
    continueTraining: 'Continuer la formation',
    graduated: 'Félicitations !',
    downloader: {
      preload: 'Télécharger',
      stop: 'Stop',
      init: 'Initialisation…',
      lastUpdate: 'Dernière mise à jour : ',
    },
  },
  trainingScreens: {
    review: 'en savoir plus',
    start: 'Commencer',
    continue: 'Continuer',
    restart: 'Recommencer',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number} effectués',
    unlock:
      'Pour débloquer ce chapitre, terminez le chapitre {number} de la formation.',
    unlockSubtitle:
      'Pour débloquer plus de chapitres, terminez les chapitres consacrés à la formation.',
    allUnlocked: 'vous avez validé tous les chapitres !',
    certificate: 'Attestation',
    courseComplete: 'Continuer',
    endReached: 'Vous avez terminé',
    retainEnd:
      'Naviguez dans ce chapitre à l’aide de la barre supérieure ou appuyez sur le bouton « Retour » pour revenir à l’aperçu.',
    watchListenRead: 'Regardez, écoutez et lisez',
    trouble:
      'Il semblerait que vous rencontriez un problème. Veuillez lire de nouveau le contenu de la ou des pages précédentes et réessayez.',
    confirm: 'Confirmez votre réponse',
    choose: 'Veuillez choisir une réponse',
    skip: 'Retour >',
    viewAllTitle: 'Conseils concernant la formation',
    viewAll:
      'Avant de passer à la page suivante, veuillez cliquer sur les icônes pour afficher le contenu supplémentaire. Nous vous proposons des vidéos, des cartes et d’autres informations utiles pour compléter votre formation et vous aider à atteindre le statut SPÉCIALISTE.',
    fillBlanks: 'Remplissez les espaces vides :',
    next: 'Question suivante',
    retry: 'Veuillez réessayer',
    fastTrackText: {
      success:
        'Félicitations, vous avez réussi le cours accéléré et débloqué le reste de la formation.',
      failed:
        'Malheureusement, vous n’avez pas réussi le cours accéléré. Vous pouvez recommencer la formation pour décrocher votre diplôme !',
    },
    fastTrack: 'Devenez…',
    fastTrackExplanation: '...',
    fastTrackButton: 'Cliquez ici pour suivre…',
    grading: 'Votre score final s’élève à : {grade} %',
  },
  nav: {
    home: 'Accueil',
    train: 'Formation',
    learn: 'Formation',
    retain: 'retenir',
    directory: 'Répertoire',
    showcases: 'En vitrine',
    promote: 'Promouvoir',
    sell: 'Vendre',
    info: 'Informations',
    rewards: 'Récompenses',
    media: 'Média',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Afficher le diplôme',
    accountSettings: 'Paramètres du compte',
    messages: 'Messages',
    search: 'Rechercher',
  },
  contentHeaders: {
    train: 'Formation',
    retain: 'Principaux points à retenir',
    subapps: 'Modules pour les spécialistes des Bahamas',
    maintrainings: 'LES BASES',
    subtrainings: 'MODULES DE SPÉCIALISATION',
  },
  pageDescriptions: {
    train: 'Apprenez, impliquez-vous et devenez un·e spécialiste.',
    retain:
      'les informations incontournables pour devenir un expert de la destination et accroître vos réservations sur Les Bahamas. Utilisez cette section pour répondre à une question sur un produit ou pour créer une présentation commerciale, à n’importe quel moment et depuis n’importe quel appareil.',
    promote: 'Présenter la destination à vos clients et prospects',
    sell: 'Répondez aux questions de vos clients et concrétisez la vente',
    favorites: 'Consultez vos contenus favoris',
    search: 'Consultez tous les contenus',
    subapps: 'Oui',
    maintrainings: 'Terminez ces modules de base pour obtenir votre diplôme.',
    subtrainings:
      'Sortez le grand jeu et gagnez un badge pour chacun des modules ci-dessous.',
  },
  general: {
    chapterTitle: 'Chapitre ',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    previous: 'Précédent',
    submit: 'Envoyer',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    showcase: 'En vitrine',
    logIn: 'Connexion',
    logOut: 'Déconnexion',
    viewItem: 'Afficher {type}',
    imageNotFound: 'Image non trouvée',
    noResultsFor: 'Nous n’avons trouvé aucun résultat pour : {{query}}',
    noFavorites: 'Vous n’avez pas encore de favoris.',
    noMessages: 'Vous n’avez pas encore reçu de messages !',
    resultsFor: 'Résultats pour : {{query}}',
    showAll: 'Afficher tout',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: 'Erreur 404 - Page non trouvée',
    oops: 'Oh oh !',
    overview: 'Revenir à l’aperçu',
    complete: 'Continuer',
    courseComplete: 'Cours terminé !',
    chapterComplete: 'Chapitre terminé !',
    message: '{count} message',
    messagePlural: '{count} messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site internet',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faites tourner les cadrans pour sélectionner la bonne réponse',
    fitb: 'Remplissez les espaces vides',
    flip: 'Changez le numéro pour sélectionner la bonne réponse',
    multipleChoice: 'Choisissez la ou les bonnes réponses',
    slider: 'Choisissez la bonne réponse à l’aide du curseur',
    map: 'Saisissez la réponse en appuyant au bon endroit de la carte',
    dropdown: 'Choisissez…',
    true: 'Vrai',
    false: 'Faux',
  },
  reportCard: {
    download: 'TÉLÉCHARGER',
    email: 'E-mail',
    print: 'Imprimer',
  },
  cookies: {
    consent: 'JE SUIS D’ACCORD',
    optout: 'Désinscription',
    settings: 'Paramètres de confidentialité',
    message:
      'Vous ne nous avez pas fait part de vos préférences concernant la confidentialité de vos données ! Ce n’est pas dramatique, mais nous aimerions vous proposer une expérience optimale avec Sales Companion',
    disabled:
      'Il semblerait que vous ayez désactivé l’utilisation des cookies.',
    use: 'Il est nécessaire d’utiliser les cookies dans l’application {{appName}} pour bénéficier de la meilleure expérience possible.',
    details: 'Pourquoi utilisons-nous les cookies ?',
    enable: 'Pour voir comment activer les cookies, cliquez {{here}}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: 'Vous n’êtes pas connecté·e',
    title: 'Vous devez vous connecter pour afficher ce contenu',
    guest: 'Invité·e',
  },
  demo: {
    message:
      'Ce site internet est une version de démonstration du produit final. Il est en phase de développement et n’est pas encore terminé.',
    consent: 'Compris !',
  },
  share: {
    header: 'Partagez cette ressource sur votre réseau social préféré !',
    download: 'TÉLÉCHARGER',
  },
  sharing: {
    copyURL: 'Copier le lien',
    copied: 'Copié',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header:
      'Il semblerait que vous tentiez d’accéder à l’application {appName} depuis un appareil mobile.',
    body: "Pour télécharger ce programme, veuillez vous rendre dans votre magasin d'applications et saisissez {appName} ou cliquez sur l’un des boutons ci-dessous.",
    benefits: {
      1: 'Attestation de formation',
      2: 'Supports marketing de qualité gratuits',
      3: 'Enregistrez-vous pour tenter de participer à un voyage de familiarisation',
      4: 'Informations et ressources commerciales à fort impact',
      5: 'Accéder à l’application mobile Sales Companion',
      6: 'Conseils en matière de vente',
      header: 'Vous obtiendrez ainsi :',
    },
  },
  custom: {
    splitUsers: 'Je suis un·e',
    brandAmbassador: 'Représentant·e de la marque',
    travelPro: 'Spécialiste du tourisme',
  },
  rewards: {
    menu: {
      home: 'Accueil\nRécompenses',
      achievements: 'Réalisations\nFormation',
      bookings: 'incentives\nBadges',
      form: 'Soumettre\nRéservations',
    },
    rewards: 'Récompenses',
    title: 'Bienvenue dans le Centre des récompenses et des réalisations',
    subheader:
      'Suivez et partagez les offres incitatives et les réalisations liées aux formations',
    button: 'Soumettez votre réservation',
    viewAllBookings: 'Réservations',
    viewDashboard: 'Tableau de bord des points',
    viewRewards: 'Vue d’ensemble',
    overview: {
      valid:
        '*Les réservations saisies ne sont valides qu’une fois le voyage du client terminé.',
    },
    home: {
      entries: 'Entrées actuelles',
      trainingAchievements: 'RÉALISATIONS LIÉES AUX FORMATIONS',
      trainingAchievementsText:
        'Suivez vos progrès de formation, vos certifications et votre statut de récompenses (Bronze, Argent, Or, Platine) sur cette page. Vous pourrez également télécharger et partager votre diplôme de Spécialiste des États-Unis, ainsi que tous les badges que vous avez obtenus dans les sections Expériences et Spécialisations des partenaires.',
      bookingContests: 'TABLEAU DE BORD DES OFFRES INCITATIVES',
      bookingContestsText:
        'Suivez et gérez facilement les programmes d’offres incitatives en cours sur le Tableau de bord des offres incitatives. ',
      submitBooking: 'SOUMETTRE DES RÉSERVATIONS',
      submitBookingText:
        'C’est ici que vous soumettrez les réservations pour les inclure dans les offres incitatives à la réservation.',
      currentContest: 'OFFRES INCITATIVES EN COURS',
      noContests:
        'Il n’y a actuellement aucune offre incitative liée aux badges.',
      contestTerms: 'Conditions générales',
      noContest: "Le concours n'est actuellement pas disponible.",
    },
    bookingsView: {
      title: 'Réservations',
      infoMessage:
        "Trier à l'aide des boutons ci-dessus et cliquer sur n'importe quel enregistrement pour gérer les détails de la soumission. Toutes les entrées en attente seront vérifiées dans les 72 heures",
    },
    leaderboardScreen: {
      prizes: 'Prix',
      tAndC: 'Des conditions générales s’appliquent*',
    },
    dashboardView: {
      title: 'Tableau de bord des offres incitatives',
      subtitle: 'Suivez les activités relatives à vos offres incitatives ici.',
      badge: 'Offres incitatives liées aux badges',
      activity: 'Offres incitatives à la réservation',
      manage: 'Gérer les réservations',
      manageSub:
        'Suivez les réservations en cours ci-dessous, ou consultez les réservations archivées en utilisant le menu déroulant.',
      noBadgeIncentives:
        'Il n’y a actuellement aucune offre incitative liée aux badges.',
      noBookings: 'Il n’y a aucun enregistrement à afficher.',
      state: {
        approvedEntries: 'Entrées Approuvées',
        pendingEntries: 'Entrées en Attente',
        declinedEntries: 'Entrées Refusées',
        viewAll: 'Voir Tout',
      },
      currentYear: 'Année en Cours',
      archivedBookings: 'Réservations Archivées',
    },
    bookingForm: {
      title: 'Formulaire de soumission de réservation',
      subTitle: 'Entrez votre réservation :',
      required: '* Indique un champ obligatoire',
      email: "E-mail de l'agent",
      agentFirstName: "Prénom de l'agent",
      agentLastName: "Nom de l'agent",
      company: "Nom de l'entreprise",
      iata: 'IATA/CLIA #',
      stateProvince: 'État/Province',
      postalCode: 'Code postal *',
      country: 'Pays',
      bookingNumber: 'Numéro de confirmation de réservation',
      numberOfGuests: "Nombre d'adultes",
      bookingDate: 'Date de réservation',
      tourOperator: 'Grossiste',
      firstName: 'Prénom',
      lastName: 'Nom du client',
      accommodation: "Nom de l'hôtel",
      guests: 'Nombre de passagers',
      select: 'Sélectionnez une option',
      wholesaler: 'Grossiste',
      arrivalDate: "Date d'arrivée",
      departureDate: 'Date de départ',
      lengthOfStay: 'Durée du séjour (en nuits)',
      reservationNumber: "Numéro de confirmation de l'hôtel",
      rooms: 'Nombre de chambres',
      stay: 'Durée du séjour (en nuits)',
      airline: 'Compagnie aérienne / Transporteur (code à 2 lettres)',
      originAirport: "Aéroport d'origine (code à 3 lettres)",
      destination: 'Destination / Île (code à 3 lettres)',
      cost: 'Coût total de la réservation (utiliser uniquement des décimales)',
      file: 'Téléchargement de la preuve RezSnap™',
      disclaimer: '* Champs obligatoires',
      button: 'Soumettre votre réservation',
      sub: 'Vos informations',
      sub2: 'Informations sur la réservation',
      propertyCharterCompany: 'Propriété / Compagnie de charter',
      flightNumber: 'Numéro de vol',
      bookingType: 'Type de réservation',
      group: 'Groupe',
      fit: 'FIT',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Bahamas Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Retour',
    },
    thankYouPage: {
      thanks: 'Merci',
      congrats: 'Félicitations, ',
      body: 'votre réservation a bien été reçue et envoyée au superviseur de la campagne pour vérification.',
      link: 'Veuillez noter que pour faire partie des gagnants, vous devez avoir terminé la partie Les fondamentaux du USA Discovery Program',
    },
  },
  search: {
    pages: 'Pages',
    resources: 'Ressources',
  },
};
